import { FC } from 'react';
import { Box, Divider, Stack } from '@chakra-ui/react';
import {
  FileDetailsFileFragment,
  PiiStatus,
} from '../../graphql/generated';
import { FileMetadata } from '../file-metadata/file-metadata';
import { Statuses } from '../file-metadata/statuses';
import { RefetchFileDetails } from '../file-processes/file-process-utils';
import { PiiApproveContainer } from '../pii-flow/pii-approve';
import { PiiJustifyContainer } from '../pii-flow/pii-justify';
import { PiiMatches } from '../pii-flow/pii-matches';
import { FileDetailsActions } from './file-details-actions/file-details-actions';
import { TransformationErrors } from './transformation-errors';

interface Props {
  file: FileDetailsFileFragment;
  refetchFileDetails: RefetchFileDetails;
}

export const FileDetails: FC<Props> = ({ file, refetchFileDetails }) => {
  const { transformation } = file;

  return (
    <Stack
      spacing="12"
      data-testid="file-details"
      maxWidth={{ sm: '100%', md: '50%' }}
    >
      <Box>
        <FileMetadata file={file} />
        <Statuses file={file} refetchFileDetails={refetchFileDetails} />
      </Box>
      <FileDetailsActions file={file} />
      {file.piiStatus !== PiiStatus.APPROVED && file.piiDetails?.matches && (
        <PiiMatches matches={file.piiDetails.matches} />
      )}
      {file.canPiiJustify && (
        <>
          <Divider />
          <PiiJustifyContainer file={file} />
        </>
      )}
      {file.canPiiApprove && (
        <>
          <Divider />
          <PiiApproveContainer file={file} />
        </>
      )}
      {transformation?.errors && (
        <>
          <Divider />
          <TransformationErrors errors={transformation.errors} />
        </>
      )}
    </Stack>
  );
};
